"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const iterator_to_hash_1 = require("./iterator-to-hash");
const is_map_1 = require("./is-map");
const is_pure_array_1 = require("./is-pure-array");
const iterator_to_array_1 = require("./iterator-to-array");
const phpJsonEncode = require('locutus/php/json/json_encode');
function jsonEncode(value) {
    if (is_map_1.isMap(value)) {
        if (is_pure_array_1.isPureArray(value)) {
            value = iterator_to_array_1.iteratorToArray(value);
        }
        else {
            value = iterator_to_hash_1.iteratorToHash(value);
        }
    }
    return phpJsonEncode(value);
}
exports.jsonEncode = jsonEncode;
